import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HistoryWithdrawal.css';

interface WithdrawalTransaction {
  id: string;
  symbol: string;
  amount: string;
  date: string;
  status: 'completed' | 'pending';
  icon: string;
  color: string;
}

const mockWithdrawals: WithdrawalTransaction[] = [
  {
    id: '1',
    symbol: 'USDT',
    amount: '100.00000000 USDT',
    date: 'Yesterday at 4:46 PM',
    status: 'completed',
    icon: '₮',
    color: '#26a17b'
  },
  {
    id: '2',
    symbol: 'USDT',
    amount: '50.00000000 USDT',
    date: 'Dec 13, 2024 at 2:30 PM',
    status: 'completed',
    icon: '₮',
    color: '#26a17b'
  },
  {
    id: '3',
    symbol: 'BTC',
    amount: '0.00024000 BTC',
    date: 'Dec 12, 2024 at 10:15 AM',
    status: 'completed',
    icon: '₿',
    color: '#f7931a'
  }
];

const HistoryWithdrawal: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'deposits' | 'withdrawals' | 'swaps'>('withdrawals');
  const [timeFilter] = useState('Past 7 days');
  const [statusFilter] = useState('All');
  const [activeNav, setActiveNav] = useState<string>('history');

  const handleNavClick = (nav: string) => {
    setActiveNav(nav);
    if (nav === 'home') {
      navigate('/dashboard');
    }
  };

  const handleTabClick = (tab: 'deposits' | 'withdrawals' | 'swaps') => {
    setActiveTab(tab);
    if (tab === 'deposits') {
      navigate('/history-deposit');
    }
  };

  return (
    <div className="history-withdrawal-container">
      <header className="history-withdrawal-header">
        <h1 className="history-withdrawal-title">History</h1>
      </header>

      <div className="history-withdrawal-content">
        <div className="history-withdrawal-tabs">
          <button
            className={`history-withdrawal-tab ${activeTab === 'deposits' ? 'active' : ''}`}
            onClick={() => handleTabClick('deposits')}
          >
            Deposits
          </button>
          <button
            className={`history-withdrawal-tab ${activeTab === 'withdrawals' ? 'active' : ''}`}
            onClick={() => handleTabClick('withdrawals')}
          >
            Withdrawals
          </button>
          <button
            className={`history-withdrawal-tab ${activeTab === 'swaps' ? 'active' : ''}`}
            onClick={() => handleTabClick('swaps')}
          >
            Swaps
          </button>
        </div>

        <div className="history-withdrawal-main">
          <div className="history-withdrawal-filters">
            <div className="history-withdrawal-filter-group">
              <label className="history-withdrawal-filter-label">Time</label>
              <button className="history-withdrawal-filter-button">
                <span>{timeFilter}</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <div className="history-withdrawal-filter-group">
              <label className="history-withdrawal-filter-label">Status</label>
              <button className="history-withdrawal-filter-button">
                <span>{statusFilter}</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>

          <div className="history-withdrawal-list">
            {mockWithdrawals.map((transaction) => (
              <button key={transaction.id} className="history-withdrawal-item">
                <div className="history-withdrawal-item-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 21V3M12 3L5 10M12 3L19 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="history-withdrawal-item-info">
                  <div className="history-withdrawal-item-row">
                    <span className="history-withdrawal-item-symbol">{transaction.symbol}</span>
                    <span className="history-withdrawal-item-amount">{transaction.amount}</span>
                  </div>
                  <div className="history-withdrawal-item-row">
                    <span className="history-withdrawal-item-date">{transaction.date}</span>
                    <span className={`history-withdrawal-item-status ${transaction.status}`}>
                      {transaction.status === 'completed' ? 'Completed' : 'Pending'}
                    </span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>

      <nav className="history-withdrawal-nav">
        <button
          className={`nav-item ${activeNav === 'home' ? 'active' : ''}`}
          onClick={() => handleNavClick('home')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Home</span>
        </button>
        <button
          className={`nav-item ${activeNav === 'markets' ? 'active' : ''}`}
          onClick={() => handleNavClick('markets')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 12L18 16L14 12L10 16L6 12L2 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M22 6L18 10L14 6L10 10L6 6L2 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Markets</span>
        </button>
        <button
          className={`nav-item ${activeNav === 'trade' ? 'active' : ''}`}
          onClick={() => handleNavClick('trade')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2V22M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Trade</span>
        </button>
        <button
          className={`nav-item ${activeNav === 'history' ? 'active' : ''}`}
          onClick={() => handleNavClick('history')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 21L12 16L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>History</span>
        </button>
        <button
          className={`nav-item ${activeNav === 'assets' ? 'active' : ''}`}
          onClick={() => handleNavClick('assets')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Assets</span>
        </button>
      </nav>
    </div>
  );
};

export default HistoryWithdrawal;